import { ProjectFeature } from '@civilgrid/utils/src/common/featureAccess';

/**
 * Per-organization feature flags stored in `organizations.specialFeatures`. Distinct from PostHog
 * flags. Kept in this store-free module (no `~/store` import) so the data + mapping below can be unit
 * tested without pulling in the app store/MSW; `FeatureFlags` (which reads the store) re-exports these.
 */
export enum OrgFeatureFlag {
  UtilitiesTabV2 = 'utilitiesV2',
  Drf = 'drf',
  AntennaMap = 'antennaMap',
  FullProjectZoning = 'fullProjectZoning',
  CircleProjects = 'circleProjects',
  EnvironmentalStudyData = 'environmentalStudyData',
  ConflictsSummary = 'conflictsSummary',
  ProjectSegmentLimit100 = 'project-segment-limit-100',
  /** Marks the org used for customer demos; internal-only admin pages stay out of the top nav there. */
  DemoOrg = 'demoOrg',
}

/**
 * Legacy org feature flags that still grant access to a project feature. Historically these features
 * were gated ONLY by the org flag; now they are also in the feature matrix. `hasFeatureAccess` ORs the
 * two so orgs provisioned before feature-provisioning keep access even though the code default is
 * off/empty. Only the features listed here consult a legacy flag; everything else uses the matrix alone.
 */
export const FEATURE_LEGACY_ORG_FLAG: Partial<Record<ProjectFeature, OrgFeatureFlag>> = {
  [ProjectFeature.AntennaMap]: OrgFeatureFlag.AntennaMap,
  [ProjectFeature.EnvironmentalStudies]: OrgFeatureFlag.EnvironmentalStudyData,
  [ProjectFeature.Zoning]: OrgFeatureFlag.FullProjectZoning,
};
